// Mobile scroll position fix utility
export const ensureTopScroll = () => {
  window.scrollTo(0, 0);
};

// Initialize mobile scroll fixes - mobile-only
export const initMobileScrollFixes = () => {
  // We remove the aggressive scroll locking during loading.
  // The loading screen is full-screen and fixed, so users cannot interact with the page anyway.
  // This cleanly avoids all scroll locking bugs on mobile browsers.
  const style = document.createElement('style');
  style.textContent = `
    /* Prevent horizontal scroll only */
    html, body {
      overflow-x: hidden !important;
      width: 100%;
    }
    #root {
      overflow-x: hidden !important;
      width: 100%;
    }
    
    /* Ensure hero section doesn't have unwanted margin */
    @media (max-width: 768px) {
      div[style*="height: 100vh"], div[style*="height: 80vh"] {
        margin-top: 0 !important;
        box-sizing: border-box !important;
      }
    }
  `;
  
  if (!document.head.querySelector('#mobile-scroll-fix')) {
    style.id = 'mobile-scroll-fix';
    document.head.appendChild(style);
  }
};

// Scroll to top after loading
export const scrollToTopAfterLoad = () => {
  // Mobile - immediate positioning without jarring movement
  if (window.innerWidth <= 768) {
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = 'smooth';
      document.body.style.scrollBehavior = 'smooth';
    }, 100);
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

// Clean up any remaining scroll locks if they exist
export const forceEnableMobileScroll = () => {
  document.body.classList.remove('freeze-screen', 'no-scroll');
  
  // Clean up inline styles that might have been left by older logic
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.height = '';
  
  document.documentElement.style.overflow = '';
  document.documentElement.style.position = '';
  document.documentElement.style.height = '';
  
  document.body.classList.add('loading-complete', 'loaded');
  document.documentElement.classList.add('loading-complete', 'loaded');
  
  console.log('Mobile scroll normalized');
};